import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import useQueryParams from "../../hooks/useQueryParams";
import { DEFAULT_PER_PAGE } from "../../utilities/constants";

const Pagination = ({ totalElements, pageParam }) => {
  const { queryParams } = useQueryParams();
  const navigate = useNavigate();
  const location = useLocation();
  const maxPageButtons = 5;

  // Always keep state in 0-based
  const param = pageParam || "pageNo";
  const pageNo = parseInt(queryParams.get(param) || "0", 10);

  // const pageNo = parseInt(queryParams.get(pageParam || "pageNo") || "0", 10);
  const pageSize = parseInt(queryParams.get("pageSize") || DEFAULT_PER_PAGE);
  const totalPages = Math.ceil(totalElements / pageSize);

  const handlePageChange = (pageIndex) => {
    if (pageIndex >= 0 && pageIndex < totalPages) {
      queryParams.set(param, pageIndex);
      queryParams.set("pageSize", pageSize);
      navigate({
        pathname: location.pathname,
        search: `?${queryParams.toString()}`,
      });
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const half = Math.floor(maxPageButtons / 2);
    let start = Math.max(0, pageNo - half);
    let end = start + maxPageButtons - 1;

    if (end >= totalPages) {
      end = totalPages - 1;
      start = Math.max(0, end - maxPageButtons + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return { pages, showPrevDots: start > 0, showNextDots: end < totalPages - 1 };
  };

  const { pages, showPrevDots, showNextDots } = getPageNumbers();

  return (
    <div className="flex justify-center items-center space-x-2 mt-6">
      <button
        onClick={() => handlePageChange(0)}
        disabled={pageNo === 0}
        className="p-2 rounded-md border bg-white shadow hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <FaAngleDoubleLeft />
      </button>

      {/* Prev */}
      <button
        onClick={() => handlePageChange(pageNo - 1)}
        disabled={pageNo === 0}
        className="p-2 rounded-md border bg-white shadow hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed ark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 "
      >
        <FaAngleLeft />
      </button>

      {showPrevDots && (
        <>
          <button
            onClick={() => handlePageChange(0)}
            className="px-3 py-1 rounded-md text-sm font-medium border bg-white text-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 "
          >
            1
          </button>
          <span className="px-2 text-gray-500">...</span>
        </>
      )}

      {pages.map((pageIndex) => (
        <button
          key={pageIndex}
          onClick={() => handlePageChange(pageIndex)}
          className={`px-3 py-1 rounded-md text-sm font-medium border 
           dark:border-gray-600 
           ${pageIndex === pageNo
              ? "bg-brand-500 text-white dark:bg-brand-600 dark:text-white"
              : "bg-white text-gray-700 hover:bg-gray-100 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700"
            }`}
        >
          {pageIndex + 1}
        </button>
      ))}

      {showNextDots && (
        <>
          <span className="px-2 text-gray-500">...</span>
          <button
            onClick={() => handlePageChange(totalPages - 1)}
            className="px-3 py-1 rounded-md text-sm font-medium border bg-white text-gray-700  dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100  hover:bg-gray-100"
          >
            {totalPages}
          </button>
        </>
      )}

      {/* Next */}
      <button
        onClick={() => handlePageChange(pageNo + 1)}
        disabled={pageNo === totalPages - 1}
        className="p-2 rounded-md border bg-white shadow hover:bg-gray-100  dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100  disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <FaAngleRight />
      </button>

      <button
        onClick={() => handlePageChange(totalPages - 1)}
        disabled={pageNo === totalPages - 1}
        className="p-2 rounded-md border bg-white shadow hover:bg-gray-100  dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100  disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <FaAngleDoubleRight />
      </button>
    </div>
  );
};

export default Pagination;
